module.exports = __webpack_public_path__ + "img/satispay.852575bc.svg";